const BLOCKED_TAGS = ['script', 'iframe', 'object', 'embed', 'style', 'link', 'meta'];

const stripEventAttributes = (root: ParentNode) => {
  const elements = root.querySelectorAll('*');
  elements.forEach((el) => {
    Array.from(el.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();
      const value = attr.value.trim().toLowerCase();
      if (name.startsWith('on')) {
        el.removeAttribute(attr.name);
        return;
      }
      if ((name === 'href' || name === 'src') && value.startsWith('javascript:')) {
        el.removeAttribute(attr.name);
      }
    });
  });
};

export const sanitizePolicyHtml = (html?: string | null): string => {
  const source = html || '<p>No active policy content available.</p>';
  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return source;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(source, 'text/html');

  BLOCKED_TAGS.forEach((tag) => {
    doc.querySelectorAll(tag).forEach((node) => node.remove());
  });
  stripEventAttributes(doc);
  return doc.body.innerHTML || '<p>No active policy content available.</p>';
};
